import template from './acris-blog-list.html.twig';

const { Mixin, Data: { Criteria }, Component } = Shopware;

Component.register('acris-blog-list', {
    template,

    inject: ['repositoryFactory'],

    emits: ['on-update-total'],

    mixins: [
        Mixin.getByName('listing'),
        Mixin.getByName('notification'),
        Mixin.getByName('placeholder')
    ],

    data() {
        return {
            sortBy: 'publicationDate',
            sortDirection: 'DESC',
            items: null,
            isLoading: false,
            showDeleteModal: false,
            repository: null,
            total: 0,
            currentFlow: {},
            selectedItems: [],
            isDeleting: false
        };
    },

    metaInfo() {
        return {
            title: this.$createTitle()
        };
    },

    computed: {
        blogRepository() {
            return this.repositoryFactory.create('acris_blog');
        },

        blogCriteria() {
            const criteria = new Criteria(this.page, this.limit);

            if (this.searchTerm) {
                criteria.setTerm(this.searchTerm);
            }

            criteria
                .addSorting(Criteria.sort(this.sortBy, this.sortDirection))
                .addSorting(Criteria.sort('updatedAt', 'DESC'));

            criteria.addAssociation('blogAuthor');
            criteria.addAssociation('salesChannels');
            criteria.addAssociation('blogGroups');
            criteria.addAssociation('rules');

            return criteria;
        },

        columns() {
            return this.getColumns();
        }
    },

    watch: {
        searchTerm(value) {
            this.onSearch(value);
        },
    },

    created() {
        this.createComponent();
    },

    methods: {
        createComponent() {
            this.getList();
        },

        getList() {
            this.isLoading = true;

            return this.blogRepository.search(this.blogCriteria).then((items) => {
                this.total = items.total;
                this.items = items;
            }).finally(() => {
                this.isLoading = false;
            });
        },

        onDelete(id) {
            this.showDeleteModal = id;
        },

        onCloseDeleteModal() {
            this.showDeleteModal = false;
        },

        onDuplicate(item) {
            this.isLoading = true;

            this.blogRepository.clone(item.id, Shopware.Context.api)
                .then((newBlog) => {
                    this.reloadEntity(item, newBlog);
                })
                .catch(() => {
                    this.isLoading = false;
                    this.createNotificationError({
                        message: this.$tc('global.notification.unspecifiedSaveErrorMessage'),
                    });
                }).finally(() => {
                    this.isLoading = false;
                });
        },

        reloadEntity(refBlog, newBlog) {
            this.blogRepository
                .get(newBlog.id, Shopware.Context.api, this.blogCriteria)
                .then((entity) => {
                    this.item = entity;
                    this.item.internalName = `(copy) ${refBlog.internalName}`;
                    this.item.active = false;
                    this.item.rules = refBlog.rules;
                    this.item.salesChannels = refBlog.salesChannels;
                    this.item.blogGroups = refBlog.blogGroups;
                    this.item.cmsPageId = null;
                    this.item.mediaId = null;
                    this.item.contentType = 'direct';
                    this.blogRepository.save(this.item, Shopware.Context.api)
                        .then(() => {
                            this.$router.push(
                                {
                                    name: 'acris.blog.detail',
                                    params: { id: newBlog.id }
                                }
                            );
                        });
                });
        },

        updateRecords(result) {
            this.items = result;
            this.total = result.total;

            this.$emit('on-update-total', this.total);
        },

        selectionChange(selection) {
            this.selectedItems = Object.values(selection);
        },

        getColumns() {
            return [{
                property: 'internalName',
                inlineEdit: 'string',
                label: 'acris-blog.list.columnInternalName',
                routerLink: 'acris.blog.detail',
                allowResize: true,
                width: '150px',
                primary: true
            }, {
                property: 'active',
                label: 'acris-blog.list.columnActive',
                inlineEdit: 'boolean',
                allowResize: true,
                align: 'center',
                width: '80px'
            }, {
                property: 'publicationDate',
                label: 'acris-blog.list.columnPublicationDate',
                allowResize: true
            }, {
                property: 'author',
                label: 'acris-blog.list.columnAuthor',
                allowResize: true,
                sortable: false
            }, {
                property: 'groups',
                label: 'acris-blog.list.columnGroup',
                allowResize: true,
                sortable: false
            }, {
                property: 'salesChannels',
                label: 'acris-blog.list.columnSalesChannels',
                allowResize: true,
                sortable: false
            }, {
                property: 'rules',
                label: 'acris-blog.list.columnRules',
                allowResize: true,
                sortable: false
            }];
        },

        onChangeLanguage(languageId) {
            this.getList(languageId);
        }
    }
});

